import Router from './pages'
import './styles'

function App() {
  return (
    <Router />
  )
}

export default App
